<template>
  <div class="card">
    <img :src="require(`@/assets/icons/${icon}`)" alt="icon" />
    <h3 class="card__title">{{ cardTitle }}</h3>
  </div>
</template>

<script>
export default {
  name: 'CardIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    title() {
      return 'hello';
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  min-width: 180px;
  max-width: calc((100% - 3 * 60px) / 6);
  background-color: hsl(var(--clr-primary-100));

  padding: 10px;
  text-align: center;
  border-radius: 8px;
  transition: transform 0.3s;
  border: 1px solid hsl(var(--clr-primary-700));
  border-bottom: hsl(var(--clr-primary-700));
  box-shadow: 6px 6px 7px -5px rgba(23, 65, 105, 0.4);

  &__title {
    width: 60%;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: hsl(var(--clr-primary-300));
  }

  &__text {
    font-size: 12px;
    line-height: 18px;
  }

  &:hover {
    transform: translateY(-6px) scale(1.03);
  }
}

@media (max-width: 900px) {
  .card {
    &__title {
      font-size: 12px;
      width: 70%;
    }

    &__text {
      font-size: 12px;
      line-height: 18px;
    }
  }

  .card + .card {
    margin-top: 20px;
  }
}
</style>
